"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFormStatus;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getFormStatus(state = {}) {
  const form_status = [{
    label: 'info',
    suffix: '--green'
  }, {
    label: 'warning',
    suffix: '--orange'
  }, {
    label: 'error',
    suffix: '--red'
  }];

  /**
   * Map all status from component.state and return information messages accordingly.
   *
   * @param    { Object }    status_data    Infos messages to display.
   * @param    { String }    index          Iteratof.
   *
   * @return    [Array]      Renderable React elements.
   */
  let status = form_status.filter(status_data => typeof state[status_data.label] !== 'undefined').map(function (status_data, index) {
    var message = /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: 'c-message ' + 'c-message' + status_data.suffix
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-message__content"
    }, state[status_data.label]));
    return message;
  });
  return status;
}
